import { isDefined } from '@interacta-shared/util';
import { Server2Delta } from '@modules/core/helpers/delta/server-2-delta.class';
import { Delta } from 'quill/core';
import {
    AIContentGenerationResponse,
    AIContentGenerationResponseDetail,
    AIMessage,
    AIMessageType,
    AIRole,
} from './ai.model';

export function toAIMessage(result: any): AIMessage {
    const answers: any[] = result.answers ?? [];

    return {
        id: answers[0].id,
        role: AIRole.MODEL,
        message: answers
            .map((a) => a.message)
            .filter(isDefined)
            .join('\n'),
        messageType: AIMessageType.STANDARD,
        timestamp: answers[0].creationTimestamp,
        alreadyAnimated: false,
    };
}

export function toAIContentGenerationContents(
    result: any[],
): AIContentGenerationResponse {
    const converter = new Server2Delta();
    return {
        contents: result.map(({ text, toneType }) => {
            const detail: AIContentGenerationResponseDetail = {
                text: converter.process(text) ?? new Delta(),
                toneType,
            };

            return detail;
        }),
    };
}
